export default "/assets/images/wildfire-smoke-video-thumbnail.557a6d426ab6af42.jpg";